import { get } from "../utils/http.util";

interface VerificationStatus {
    walletId: string;
    isVerified: boolean;
    requiresVerification: boolean;
    totalBetAmount: number;
}

const baseUrl = process.env.REACT_APP_CHECKIN_API_URL ?? 'https://dev-api.checkin.degencoinflip.com/v1';

export const getVerificationStatus = async (walletId: string): Promise<VerificationStatus> => {
    const response = await get(
        `${baseUrl}/kyc-profile/public/${walletId}/status`
    );
    return response?.payload;
};